import type { Category } from '../types/GraphQL';

export type UseCategory = Category & {
  id: string;
  orderHint: string;
  description: string;
  name: string;
  slug: string;
  slugAllLocales: Record<string, string>;
  canonicalUrl: string;
  key: string;
  metaTitle: string;
  parent: {
    slugAllLocales: Record<string, string>;
  };
  metaDescription: string;
  headlineTitle: string;
  isHidden: boolean;
  hideChartSize: boolean;
  childrenItems: Category[];
  saleMetadata: {
    metaTitle?: string;
    metaDescription?: string;
    headline?: string;
    description?: string;
  };
  redirectionRules?: {
    statusCode: number;
    redirectUrl: string;
  };
};

export const useStateCategory = () => useState<UseCategory | undefined>('currentCategory');
